import { Component, computed, inject, input, output } from "@angular/core";
import { KENDO_DIALOGS, WindowState } from "@progress/kendo-angular-dialog";
import { ICON_SETTINGS } from "@progress/kendo-angular-icons";
import { FormsModule } from "@angular/forms";
import { CustomMessagesService } from "../../services/custom-messages.service";
import { WINDOW_HEIGHT, WINDOW_WIDTH } from "../../app.const";
import { IconListComponent } from "../../archive-view/mode-reordering/icon-list/icon-list.component";
import { MenuReorderingService } from "../../services/menu.reordering.services";
import { IconData } from "../../archive-view/mode-reordering/icon-list/icon-utils";
import { WindowTitlebarComponent } from "../window-titlebar/window-titlebar.component";

@Component({
  selector: "app-icon",
  imports: [
    KENDO_DIALOGS,
    FormsModule,
    IconListComponent,
    WindowTitlebarComponent,
  ],
  providers: [{ provide: ICON_SETTINGS, useValue: { type: "svg" } }],
  templateUrl: "./icon.component.html",
  styleUrl: "./icon.component.scss",
})
export class IconComponent {
  readonly menuReorderingService = inject(MenuReorderingService);
  protected readonly customMessagesService = inject(CustomMessagesService);

  selectedIconId = input.required<number>();
  selectedLabel = input.required<string>();
  closed = output<void>();

  message = computed(() =>
    this.customMessagesService
      .translate("icon_msg_pour")
      .replace("{VAR}", this.selectedLabel()),
  );

  public windowState: WindowState = "default";
  public windowWidth = WINDOW_WIDTH;
  public windowHeight = WINDOW_HEIGHT;

  close(): void {
    this.closed.emit();
  }

  onIconClick(icon: IconData): void {
    this.closed.emit();
    this.menuReorderingService.updateMenuNodeIcon(
      icon.name,
      this.selectedIconId(),
    );
  }
}
